import { render, staticRenderFns } from "./OriginalAnalysisBoard.vue?vue&type=template&id=5e3e0e30&scoped=true&"
import script from "./OriginalAnalysisBoard.vue?vue&type=script&lang=js&"
export * from "./OriginalAnalysisBoard.vue?vue&type=script&lang=js&"
import style0 from "./OriginalAnalysisBoard.vue?vue&type=style&index=0&id=5e3e0e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e0e30",
  null
  
)

export default component.exports